import PaymentTouchnet from 'hb-react/frontoffice/components/payments/PaymentTouchnet';
import { usePaymentContext } from 'hb-react/shared/components/Payment/context/PaymentContext';

export const Touchnet = () => {
  const { cart, onSuccess } = usePaymentContext();

  return (
    <PaymentTouchnet
      getSecureLinkTicketUrl={Routes.touchnet_generate_ticket_path()}
      ticketRequestObject={ticketRequestObject(cart)}
      onSuccess={onSuccess}
      cartStatus={cart.status}
    />
  );
};

const ticketRequestObject = (cart) => ({
  message: {
    ticket_name: cart.id,
  },
});
